/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataModelMassActionPropose {
    _10TH = '10th',
    _25TH = '25th',
    _50TH = '50th',
    _60TH = '60th',
    _65TH = '65th',
    _75TH = '75th',
    _90TH = '90th',
    _95TH = '95th',
    MRP = 'MRP',
    CP1 = 'CP1',
    CUSTOM_PERCENT = 'customPercent',
    CURRENT_RANGE_SPREAD = 'currentRangeSpread',
    GUIDELINE = 'guideline',
    CURRENT_PROGRESSION = 'currentProgression',
    EMPLOYEE_WEIGHTED = 'employeeWeighted',
    LINEAR_REGRESSION = 'linearRegression',
    EXPONENTIAL_REGRESSION = 'exponentialRegression',
}
